export const BRAND = {
  navyDeep: "#071B33",
  navyBlueprint: "#0D2B4C",
  orangeConstruction: "#FF8A00",
  greenApproved: "#22C55E",
  amberWarning: "#F59E0B",
  redDanger: "#EF4444",
  bgLight: "#F5F8FC",
  cardWhite: "#FFFFFF",
  slateText: "#334155",
} as const;

export const WORKFLOW_STATUSES = [
  "Draft",
  "Submitted",
  "Approved",
  "Rejected",
  "Locked",
  "Exported",
  "Exception",
] as const;

export type WorkflowStatus = (typeof WORKFLOW_STATUSES)[number];

export const STATUS_STYLES: Record<
  WorkflowStatus,
  { bg: string; text: string; border: string; dot: string }
> = {
  Draft: {
    bg: "bg-slate-100",
    text: "text-slate-600",
    border: "border-slate-200",
    dot: "bg-slate-400",
  },
  Submitted: {
    bg: "bg-blue-50",
    text: "text-blue-700",
    border: "border-blue-200",
    dot: "bg-blue-500",
  },
  Approved: {
    bg: "bg-green-50",
    text: "text-green-700",
    border: "border-green-200",
    dot: "bg-green-approved",
  },
  Rejected: {
    bg: "bg-red-50",
    text: "text-red-700",
    border: "border-red-200",
    dot: "bg-red-danger",
  },
  Locked: {
    bg: "bg-navy-deep/5",
    text: "text-navy-deep",
    border: "border-navy-deep/20",
    dot: "bg-navy-blueprint",
  },
  Exported: {
    bg: "bg-orange-50",
    text: "text-orange-800",
    border: "border-orange-200",
    dot: "bg-orange-construction",
  },
  Exception: {
    bg: "bg-amber-50",
    text: "text-amber-800",
    border: "border-amber-200",
    dot: "bg-amber-warning",
  },
};

export const RULE_TYPES = [
  "Daily OT",
  "Double Time",
  "Weekend",
  "Holiday",
  "Night Shift",
  "Hazard",
  "Custom",
] as const;

export type RuleType = (typeof RULE_TYPES)[number];

export const RULE_STYLES: Record<RuleType, string> = {
  "Daily OT": "border-l-orange-construction bg-orange-50/50",
  "Double Time": "border-l-red-danger bg-red-50/50",
  Weekend: "border-l-navy-blueprint bg-blue-50/50",
  Holiday: "border-l-green-approved bg-green-50/50",
  "Night Shift": "border-l-indigo-500 bg-indigo-50/50",
  Hazard: "border-l-amber-warning bg-amber-50/50",
  Custom: "border-l-slate-400 bg-slate-50/50",
};

export const EQUIPMENT_TYPES = [
  "Heavy",
  "Vehicle",
  "Tool",
  "Rental",
  "Other",
] as const;

export type EquipmentType = (typeof EQUIPMENT_TYPES)[number];

export const EQUIPMENT_STYLES: Record<EquipmentType, string> = {
  Heavy: "bg-navy-deep text-white",
  Vehicle: "bg-navy-blueprint text-white",
  Tool: "bg-slate-600 text-white",
  Rental: "bg-orange-construction text-navy-deep",
  Other: "bg-slate-200 text-slate-700",
};
